// 启动页（index.html 里的 #boot-splash）在 React 挂载后淡出移除。
// 用独立函数而不是写在 main.tsx 里，是为了能直接被测试覆盖。
export function dismissBootSplash(target: Document = document, fadeMs = 260): void {
  const splash = target.getElementById('boot-splash')
  if (!splash) return
  splash.classList.add('boot-splash-out')
  if (typeof window === 'undefined') { splash.remove(); return }
  window.setTimeout(() => splash.remove(), fadeMs)
}
